/**
 *
 *  Reviews Header Modal
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 23/08/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";
import { bool, func, arrayOf, shape, string, number } from "prop-types";

// Components
import TrainerRating from "../../TrainerRating/TrainerRating";

// Utils
import { getPartnerPictureUrl } from "../../../utils";

// Icons
import CloseIcon from "../../../icons/CloseIcon";

// Images
import defaultPartnerPhoto from "../../../images/generic-trainerphoto.svg";

export const ReviewsHeader = ({
  isCompact,
  partnerSummary,
  partnerProducts,
  onClose,
}) => {
  const partnerPictureUrl =
    partnerSummary && getPartnerPictureUrl(partnerSummary);

  return (
    <div
      className="tbk--ml-2 tbk--mt-2 tbk--mr-2 tbk-flex tbk-items-center tbk-rounded-lg tbk-bg-basic-white tbk-p-2 tbk-shadow-trube md:tbk-mt-0 md:tbk-mr-0 md:tbk-ml-0 lg:tbk-p-4"
      // onClick={handlePartnerLinkClick}
    >
      <button
        onClick={onClose}
        className="tbk-absolute tbk-top-2 tbk-right-3 tbk-z-10 tbk-text-coral"
      >
        <CloseIcon />
      </button>
      <div className="tbk-mr-3 tbk-h-[48px] tbk-w-[48px] tbk-shrink-0 lg:tbk-h-8 lg:tbk-w-8">
        {partnerPictureUrl ? (
          <img
            className="tbk-h-full tbk-w-full tbk-rounded-lg tbk-object-cover"
            src={partnerPictureUrl ? partnerPictureUrl : undefined}
            alt={`${partnerSummary && partnerSummary.firstName} ${
              partnerSummary && partnerSummary.lastName
            }`}
          />
        ) : (
          <img
            className="tbk-rounded-lg"
            itemProp="image"
            src={defaultPartnerPhoto}
            alt={`${partnerSummary && partnerSummary.firstName} ${
              partnerSummary && partnerSummary.lastName
            }`}
          />
        )}
      </div>
      {partnerSummary && partnerSummary.firstName ? (
        <div>
          <div className="tbk-mb-2 lg:tbk-flex">
            <div
              className={`${
                isCompact
                  ? "tbk-text-main tbk-mr-1 tbk-pl-1"
                  : "tbk-text-title-medium tbk-mr-4"
              } tbk-text-primary`}
            >
              {partnerSummary.firstName}{" "}
              {isCompact ? "" : partnerSummary.lastName}
            </div>
            <TrainerRating
              className="tbk-text-main tbk-flex tbk-items-center"
              averageRatingClassName={"tbk-text-black-grey"}
              numberOfSessionsClassName={"tbk-text-grey tbk-text-main"}
              trainerRatingRecapClassName={
                isCompact
                  ? "tbk-text-secondary tbk-text-grey"
                  : "tbk-text-h3-subtitle tbk-text-black-grey"
              }
              trainerNumberOfSessionsClassName={
                isCompact
                  ? "tbk-text-small tbk-text-grey"
                  : "tbk-text-main tbk-text-grey"
              }
              partner={partnerSummary}
            />
          </div>
          {!isCompact && (
            <ul className="tbk-mb-0 tbk-hidden md:tbk-flex">
              {partnerProducts &&
                partnerProducts.slice(0, 3).map((p) => (
                  <li
                    key={p.id}
                    className="tbk-text-secondary tbk-mr-1 tbk-whitespace-nowrap tbk-rounded-lg tbk-bg-grey-light tbk-px-2 tbk-py-1.5 tbk-text-black-grey"
                  >
                    <span className="tbk-text-secondary tbk-text-black-grey">
                      {p.name}
                    </span>
                  </li>
                ))}
              <li className="tb-disciplines-skills-br" />
            </ul>
          )}
        </div>
      ) : (
        <div className="time-slots-popup-trainer-name-placeholder" />
      )}
    </div>
  );
};

ReviewsHeader.propTypes = {
  partner: shape({
    firstName: string.isRequired,
    lastName: string.isRequired,
    photo: string.isRequired,
  }),
  partnerProducts: arrayOf(shape({ id: string, name: string })),
};

export default ReviewsHeader;
